import { Box, Button, Dialog, DialogContent, DialogTitle, Select, MenuItem, TextField, Typography, IconButton, FormControlLabel, Checkbox, InputAdornment } from "@mui/material";
import { boxStyle } from "../../../theme";
import Header from "../../../components/Header";
import { useEffect, useState, useRef } from "react";
import TableADV from "./advancedVisualizer-components/tableAdVis";
import API from "../../../api";
import LinearGraph from "./advancedVisualizer-components/linearGraph";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useDrag, useDrop } from "react-dnd";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import dayjs from "dayjs";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import GroupedChart from "./advancedVisualizer-components/groupedCharts";
import CircularIndeterminate from "../../../components/circularProgress";
import AdvancedHeatMap from "./advancedVisualizer-components/heatmap";
import SaveIcon from "@mui/icons-material/Save";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const DraggableButton = ({
  children,
  type,
  onDrop,
  onClick,
  filt,
  color = "",
  textcolor = "",
  className = "",
}) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "FILTER",
    item: { type },
    filter: filt,
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      if (item && dropResult) {
        onDrop(item.type);
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));
  

  return (
    <Box ref={drag} sx={{ opacity: isDragging ? 0.5 : 1 }}>
      <Button
        sx={{
          backgroundColor: color ? color : "#3d3d3d",
          color: textcolor,
          fontWeight: 900,
        }}
        className={className}
        variant="contained"
        onClick={onClick}
      >
        {children}
      </Button>
    </Box>
  );
};

const DropBox = ({ onDrop, genGraph, apiResponse, filter }) => {

  const [{ canDrop }, drop] = useDrop(() => ({
    accept: "FILTER",
    drop: () => ({ name: "DropBox" }),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }));
  return (
    <Box
      ref={drop}
      sx={{
        display: "flex",
        width: "100%",
        height: "100%",
        justifyContent: "center",
        backgroundColor: canDrop ? "#5f6672" : "#1e1e1e",
        borderRadius: "15px",
      }}
      onDrop={(item) => { }}
    >
      <GroupedChart filter={filter} apiResponse={apiResponse} />
    </Box>
  );
};

const getLastThreeDays = () => {
  const dates = [];
  for (let i = 0; i < 3; i++) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    dates.push(date.toISOString().split("T")[0]); // Formatta la data come YYYY-MM-DD
  }
  return dates.reverse(); // In modo che la lista sia dal più vecchio al più recente
};

const AdvancedVisual = ({ customerName }) => {
  const [, setDetailSelected] = useState("");
  const [apiResponse, setApiResponse] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState({});
  const [selectedTipo, setSelectedTipo] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [charged, setCharged] = useState(false);
  const [previousFilter, setPreviousFilter] = useState({});
  const timezone = window.sessionStorage.getItem("timezone") || "UTC";
  const clearFilter = {
    tipo: [],
    dateFrom: null,
    dateTo: null,
    dettaglio: [],
    smartFilter: false,
  };
  const [filter, setFilter] = useState({
    tipo: [],
    dateFrom: getLastThreeDays()[1],
    dateTo: getLastThreeDays()[2],
    dettaglio: [],
    smartFilter: false,
  });
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const detailGraphSelected = useRef(null);

  if (!customerName && window.sessionStorage.getItem("type") === "reseller") {
    window.sessionStorage.setItem("selectedTab", "Dashboard");
    setTimeout(function checkCondition() {
      if (window.sessionStorage.getItem("selectedTab") === "Dashboard") {
        window.location.href = `/${window.sessionStorage.getItem("type")}/home`;
      } else {
        setTimeout(checkCondition, 500); // Aspetta 1 secondo e poi richiama la funzione
      }
    }, 0);
  }

  const updateRange = () => {
    if (startDate && endDate) {
      const dateStart = new Date(startDate).toISOString().split("T")[0];
      const dateEnd = new Date(endDate).toISOString().split("T")[0];
      setFilter({ ...filter, dateFrom: dateStart, dateTo: dateEnd });
    }
  };
  const handleOpenDialog = (filter_) => {
    setPreviousFilter(filter);
    setSelectedFilter(filter_);
    setOpenDialog(true);
  };

  const handleCloseFilter = () => {
    setFilter(previousFilter);
    setOpenDialog(false);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleApplyFilter = () => {
    setFilter({
      ...filter,
      tipo: selectedTipo,
    });
  };

  const handleOpenRemoveDialog = () => {
    setOpenRemoveDialog(true);
  };

  const handleCloseRemoveDialog = () => {
    setOpenRemoveDialog(false);
  };

  useEffect(() => {
    updateRange();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- updateRange is redefined every render (not memoized); adding it here would re-run this effect on every render and risk an update loop via setFilter
  }, [startDate, endDate]);

  const [subValue, setSubValue] = useState("")
  const isValidSubnet = (value) => {
    const subnetRegex = /^(?:\d{1,3}\.){3}\d{1,3}\/([1-9]|[12]\d|3[0-2])$/;
    return subnetRegex.test(value);
  };

  useEffect(() => {
    setCharged(false);
    const abortController = new AbortController();
    const { signal } = abortController;
    API.getAdvancedData(filter, signal)
      .then((response) => {
        setApiResponse(response.data);
        setCharged(true);
      })
      .catch((err) => {
        if (err.message !== "canceled") {
          console.error(err);
          setCharged(true);
        }
      });
    return () => {
      abortController.abort();
    };
  }, [filter]);

  return (
    <>
      <Dialog open={openRemoveDialog} onClose={handleCloseRemoveDialog}>
        <DialogTitle>Remove Filters</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", gap: 4, flexDirection: "column" }}>
            {filter.tipo.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 900, marginRight: 2 }}
                >
                  Selected Types:
                </Typography>
                <div style={{ display: "flex", gap: 10 }}>
                  {filter.tipo.map((element, index) => (
                    <Box>
                      <IconButton
                        sx={{ gap: 1 }}
                        onClick={() => {
                          setFilter({
                            ...filter,
                            tipo: filter.tipo.filter(
                              (type) => type !== element
                            ),
                          });
                        }}
                      >
                        <DeleteForeverIcon />{" "}
                        {element === 0
                          ? "High"
                          : element === 1
                            ? "Critical"
                            : element === 2
                              ? "Alert"
                              : "Movements"}{" "}
                      </IconButton>
                    </Box>
                  ))}
                </div>
              </Box>
            )}
            {filter.dettaglio.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 900, marginRight: 2 }}
                >
                  Selected Detail:
                </Typography>
                <div style={{ display: "flex", gap: 70 }}>
                  {filter.dettaglio.map((element, index) => (
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      <IconButton
                        sx={{ gap: 1 }}
                        onClick={() => {
                          setFilter({
                            ...filter,
                            dettaglio: filter.dettaglio.filter(
                              (detail) => detail !== element
                            ),
                          });
                        }}
                      >
                        <DeleteForeverIcon /> {element}
                      </IconButton>
                    </Box>
                  ))}
                </div>
              </Box>
            )}
            {filter.dateFrom && filter.dateTo && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 900, marginRight: 2 }}
                >
                  Date From & Date To:
                </Typography>
                <div style={{ display: "flex", gap: 70 }}>
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <IconButton
                      sx={{ gap: 1 }}
                      onClick={() => {
                        setEndDate();
                        setStartDate();
                        setFilter(({ dateFrom, dateTo, ...rest }) => rest);
                      }}
                    >
                      <DeleteForeverIcon /> {filter.dateFrom}{" "}
                      <CompareArrowsIcon fontSize="small" /> {filter.dateTo}
                    </IconButton>
                  </Box>
                </div>
              </Box>
            )}
            {filter.subnet && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 900, marginRight: 2 }}
                >
                  Selected Subnet:
                </Typography>
                <div style={{ display: "flex", gap: 70 }}>
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <IconButton
                      sx={{ gap: 1 }}
                      onClick={() => {
                        setFilter(({ subnet, ...rest }) => rest);
                      }}
                    >
                      <DeleteForeverIcon /> {filter.subnet}{" "}
                    </IconButton>
                  </Box>
                </div>
              </Box>
            )}
            {filter.ip1 && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 900, marginRight: 2 }}
                >
                  Source IP:
                </Typography>
                <div style={{ display: "flex", gap: 70 }}>
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <IconButton
                      sx={{ gap: 1 }}
                      onClick={() => {
                        setFilter(({ ip1, ...rest }) => rest);
                      }}
                    >
                      <DeleteForeverIcon /> {filter.ip1}{" "}
                    </IconButton>
                  </Box>
                </div>
              </Box>
            )}
            {filter.ip2 && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 900, marginRight: 2 }}
                >
                  Destination IP:
                </Typography>
                <div style={{ display: "flex", gap: 70 }}>
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <IconButton
                      sx={{ gap: 1 }}
                      onClick={() => {
                        setFilter(({ ip2, ...rest }) => rest);
                      }}
                    >
                      <DeleteForeverIcon /> {filter.ip2}{" "}
                    </IconButton>
                  </Box>
                </div>
              </Box>
            )}
            {filter.nip1 && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 900, marginRight: 2 }}
                >
                  Source IP is not:
                </Typography>
                <div style={{ display: "flex", gap: 70 }}>
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <IconButton
                      sx={{ gap: 1 }}
                      onClick={() => {
                        setFilter(({ nip1, ...rest }) => rest);
                      }}
                    >
                      <DeleteForeverIcon /> {filter.nip1}{" "}
                    </IconButton>
                  </Box>
                </div>
              </Box>
            )}
            {filter.nip2 && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 900, marginRight: 2 }}
                >
                  Destination IP is not:
                </Typography>
                <div style={{ display: "flex", gap: 70 }}>
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <IconButton
                      sx={{ gap: 1 }}
                      onClick={() => {
                        setFilter(({ nip2, ...rest }) => rest);
                      }}
                    >
                      <DeleteForeverIcon /> {filter.nip2}{" "}
                    </IconButton>
                  </Box>
                </div>
              </Box>
            )}
            {(filter.tipo.length !== 0 ||
              filter.dateFrom ||
              filter.dateTo ||
              filter.dettaglio.length !== 0 ||
              filter.ip1 ||
              filter.ip2 ||
              filter.subnet) && (
                <div style={{ display: "flex", alignSelf: "flex-end" }}>
                  <IconButton
                    sx={{ gap: 1, fontSize: 13 }}
                    variant="contained"
                    onClick={() => {
                      setFilter({ ...clearFilter });
                      setOpenRemoveDialog(false);
                    }}
                  >
                    <DeleteSweepIcon fontSize="large" /> Remove All
                  </IconButton>
                </div>
              )}
            {filter.tipo.length === 0 &&
              !filter.dateFrom &&
              !filter.dateTo &&
              filter.dettaglio.length === 0 &&
              !filter.ip1 &&
              !filter.ip2 && <Typography>No filter to remove</Typography>}
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: "#2a2a2a",
            borderRadius: 5,
            border: "solid 3px #459095",
            backgroundImage: "none",
          },
        }}
        open={openDialog}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleCloseDialog();
          }
        }}
      >
        <DialogTitle>Apply the filter</DialogTitle>
        <DialogContent>
          {selectedFilter === "tipo" && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: 5,
                gap: 20,
              }}
            >
              <Select
                sx={{}}
                multiple
                labelId="Type"
                id="tipo-select"
                value={selectedTipo}
                onChange={(e) => {
                  setSelectedTipo(e.target.value);
                  handleApplyFilter();
                }}
                fullWidth
              >
                <MenuItem value={1} color="red">
                  Critical
                </MenuItem>
                <MenuItem value={0}>High</MenuItem>
                <MenuItem value={2}>Alert</MenuItem>
                <MenuItem value={3}>Movements</MenuItem>
              </Select>
              <div style={{ display: "flex", gap: 20 }}>
                <Button
                  sx={{
                    backgroundColor: "#1e1e1e !important",
                    "&:hover": {
                      backgroundColor: "#eaeaea !important",
                      color: "#131C2D",
                    },
                  }}
                  fullWidth
                  className="buttonAdvancedVis"
                  variant="contained"
                  onClick={() => {
                    setOpenDialog(false);
                    handleApplyFilter();
                    setSelectedTipo([]);
                  }}
                  disabled={apiResponse.length === 0}
                >
                  Apply (Data Available: {apiResponse.length})
                </Button>
                <Button
                  className="buttonAdvancedVis"
                  variant="contained"
                  onClick={handleCloseFilter}
                  sx={{
                    backgroundColor: "#1e1e1e !important",
                    "&:hover": {
                      backgroundColor: "#eaeaea !important",
                      color: "#131C2D",
                    },
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          )}
          {selectedFilter === "data" && (
            <div
              style={{
                flexDirection: "column",
                display: "flex",
                gap: 20,
                paddingTop: 10,
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Start Date"
                  value={startDate}
                  onChange={(newDate) => setStartDate(dayjs(newDate).tz(timezone))}
                  renderInput={(params) => <TextField {...params} />}
                />
                <DatePicker
                  label="End Date"
                  value={endDate}
                  onChange={(newDate) => setEndDate(dayjs(newDate).tz(timezone))}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>

              <div style={{ display: "flex", gap: 20 }}>
                <Button
                  sx={{
                    backgroundColor: "#1e1e1e !important",
                    "&:hover": {
                      backgroundColor: "#eaeaea !important",
                      color: "#131C2D",
                    },
                  }}
                  fullWidth
                  className="buttonAdvancedVis"
                  variant="contained"
                  onClick={handleCloseDialog}
                  disabled={apiResponse.length === 0}
                >
                  Apply (Data Available: {apiResponse.length})
                </Button>
                <Button
                  className="buttonAdvancedVis"
                  variant="contained"
                  onClick={handleCloseFilter}
                  sx={{
                    backgroundColor: "#1e1e1e !important",
                    "&:hover": {
                      backgroundColor: "#eaeaea !important",
                      color: "#131C2D",
                    },
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          )}
          {selectedFilter === "dettaglio" && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: 5,
                gap: 20,
              }}
            >
              <Typography variant="h6">
                Enter the <b>LOG KEYWORD</b> , to enter more , separate them
                with a " , "
              </Typography>
              <TextField
                label="Details"
                placeholder="Ex: MALWARE, SCAN, STREAM..."
                onChange={(e) => {
                  var details = e.target.value.split(",");
                  details = details.map((element) => element.trim());
                  if (details[details.length - 1] === "") details.pop();
                  setFilter({ ...filter, dettaglio: details });
                }}
              ></TextField>
              <div style={{ display: "flex", gap: 20 }}>
                <Button
                  fullWidth
                  className="buttonAdvancedVis"
                  variant="contained"
                  onClick={handleCloseDialog}
                  disabled={apiResponse.length === 0}
                  sx={{
                    backgroundColor: "#1e1e1e !important",
                    "&:hover": {
                      backgroundColor: "#eaeaea !important",
                      color: "#131C2D",
                    },
                  }}
                >
                  Apply (Data Available: {apiResponse.length})
                </Button>
                <Button
                  className="buttonAdvancedVis"
                  variant="contained"
                  onClick={handleCloseFilter}
                  sx={{
                    backgroundColor: "#1e1e1e !important",
                    "&:hover": {
                      backgroundColor: "#eaeaea !important",
                      color: "#131C2D",
                    },
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          )}
          {selectedFilter === "ip" && (
            <div
              style={{
                display: "flex",
                gap: 20,
                paddingTop: 5,
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  gap: 20,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                {/* IP Source with Not Checkbox */}
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <TextField
                    label="IP Source"
                    value={filter.nip1 || filter.ip1 || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[0-9.]*$/.test(value)) {
                        setFilter((prev) => ({
                          ...prev,
                          [prev.notIp1 ? "nip1" : "ip1"]: value,
                          [prev.notIp1 ? "ip1" : "nip1"]: "", // Clear the opposite field
                        }));
                      }
                    }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={filter.notIp1 || false}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          setFilter((prev) => ({
                            ...prev,
                            notIp1: isChecked,
                            // Move value to the corresponding field
                            nip1: isChecked ? prev.ip1 : "",
                            ip1: isChecked ? "" : prev.nip1,
                          }));
                        }}
                      />
                    }
                    label="Not"
                  />
                </div>

                {/* IP Destination with Not Checkbox */}
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <TextField
                    label="IP Destination"
                    value={filter.nip2 || filter.ip2 || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[0-9.]*$/.test(value)) {
                        setFilter((prev) => ({
                          ...prev,
                          [prev.notIp2 ? "nip2" : "ip2"]: value,
                          [prev.notIp2 ? "ip2" : "nip2"]: "", // Clear the opposite field
                        }));
                      }
                    }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={filter.notIp2 || false}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          setFilter((prev) => ({
                            ...prev,
                            notIp2: isChecked,
                            nip2: isChecked ? prev.ip2 : "",
                            ip2: isChecked ? "" : prev.nip2,
                          }));
                        }}
                      />
                    }
                    label="Not"
                  />
                </div>
              </div>

              <div style={{ display: "flex", gap: 20 }}>
                <Button
                  fullWidth
                  className="buttonAdvancedVis"
                  variant="contained"
                  onClick={handleCloseDialog}
                  disabled={apiResponse.length === 0}
                  sx={{
                    backgroundColor: "#1e1e1e !important",
                    "&:hover": {
                      backgroundColor: "#eaeaea !important",
                      color: "#131C2D",
                    },
                  }}
                >
                  Apply (Data Available: {apiResponse.length})
                </Button>
                <Button
                  className="buttonAdvancedVis"
                  variant="contained"
                  onClick={handleCloseFilter}
                  sx={{
                    backgroundColor: "#1e1e1e !important",
                    "&:hover": {
                      backgroundColor: "#eaeaea !important",
                      color: "#131C2D",
                    },
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          )}
          {selectedFilter === "tipo" && <Button></Button>}
          {selectedFilter === "dates" && <></>}
          {selectedFilter === "dettaglio" && <></>}
          {selectedFilter === "ip" && <></>}
          {selectedFilter === "subnet" && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: 5,
                gap: 5,
              }}
            >
              <TextField
                id="subnetValue"
                label="Subnet Filter"
                variant="outlined"
                sx={{ width: "200px" }}
                slotProps={{
                  inputLabel: {shrink: true},
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => { setFilter({ ...filter, subnet: subValue }) }}
                          edge="end"
                          aria-label="update"
                          disabled={!isValidSubnet(subValue)} // Disabilita il pulsante se la subnet non è valida
                        >
                          <SaveIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }
                }}
                name="SubnetValue"
                value={subValue || ""}
                onChange={(e) => setSubValue(e.target.value)}
                error={Boolean(subValue) && !isValidSubnet(subValue)} // Mostra errore se il formato è sbagliato
                helperText={
                  subValue && !isValidSubnet(subValue)
                    ? "Invalid subnet format (ex: 192.168.1.0/24)"
                    : ""
                }
              />

              <div style={{ display: "flex", gap: 20 }}>
                <Button
                  fullWidth
                  className="buttonAdvancedVis"
                  variant="contained"
                  onClick={handleCloseDialog}
                  disabled={apiResponse.length === 0}
                  sx={{
                    backgroundColor: "#1e1e1e !important",
                    "&:hover": {
                      backgroundColor: "#eaeaea !important",
                      color: "#131C2D",
                    },
                  }}
                >
                  Apply (Data Available: {apiResponse.length})
                </Button>
                <Button
                  className="buttonAdvancedVis"
                  variant="contained"
                  onClick={handleCloseFilter}
                  sx={{
                    backgroundColor: "#1e1e1e !important",
                    "&:hover": {
                      backgroundColor: "#eaeaea !important",
                      color: "#131C2D",
                    },
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      <Box m="20px">
        {/* HEADER */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Header title="ADVANCED VISUALIZER" />
        </Box>

        <Box
          display="grid"
          marginTop={3}
          gridTemplateColumns="repeat(12, 1fr)"
          gridAutoRows="140px"
          gap="20px"
        >
          {/* ROW 1 */}
          <DndProvider backend={HTML5Backend}>
            <Box
              sx={[boxStyle,{
                p: 2,
                gridColumn: { xs: "span 12", md: "span 5" },
                display: "flex",
                flexDirection: "column",
              }]}
              gridRow="span 1"
              gap={2}
              alignItems="center"
              justifyContent="center"
            >
              <div
                style={{
                  marginLeft: 5,
                  gap: 15,
                  marginTop: -50,
                  display: "flex",
                  alignSelf: "flex",
                }}
                className="fastFilters"
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 5,
                  }}
                >
                  <div style={{ gap: 10, display: "flex" }}>
                    <Button
                      variant="contained"
                      height={4}
                      sx={{
                        fontWeight: 900,
                        backgroundColor: "#2d2d2d !important",
                        "&:hover": {
                          backgroundColor: "#eaeaea !important",
                          color: "#131C2D",
                        },
                      }}
                      style={{
                        fontSize: 10.5,
                        padding: 1,
                        paddingRight: 3,
                        paddingLeft: 3,
                      }}
                      onClick={() => {
                        let date = new Date();
                        let today = [];
                        let dataFormat = date.toISOString().split("T")[0];
                        today.push(dataFormat);
                        setFilter({
                          ...clearFilter,
                          dateFrom: today,
                          dateTo: today,
                        });
                      }}
                    >
                      Today
                    </Button>
                    <Button
                      variant="contained"
                      height={4}
                      sx={{
                        fontWeight: 900,
                        backgroundColor: "#2d2d2d !important",
                        "&:hover": {
                          backgroundColor: "#eaeaea !important",
                          color: "#131C2D",
                        },
                      }}
                      style={{
                        fontSize: 10.5,
                        padding: 1,
                        paddingRight: 3,
                        paddingLeft: 3,
                      }}
                      onClick={() => {
                        let today = new Date();
                        let yesterday = new Date();
                        yesterday.setTime(
                          yesterday.getTime() - 1 * 48 * 60 * 60 * 1000
                        );
                        setFilter({
                          ...clearFilter,
                          dateFrom: yesterday,
                          dateTo: today,
                        });
                      }}
                    >
                      Last 48 Hours
                    </Button>
                    
                    {sessionStorage.getItem("tipoLecs") === "LECS-CORE-SFP" &&
                      <Button
                      variant="contained"
                      height={4}
                      sx={{
                        fontWeight: 900,
                        backgroundColor: "#2d2d2d !important",
                        "&:hover": {
                          backgroundColor: "#eaeaea !important",
                          color: "#131C2D",
                        },
                      }}
                      style={{
                        fontSize: 10.5,
                        padding: 1,
                        paddingRight: 3,
                        paddingLeft: 3,
                      }}
                      onClick={() => {
                        let date = new Date();
                        let lastWeek = [];
                        for (let i = 1; i <= 7; i++) {
                          date.setDate(date.getDate() - 1);
                          let dataFormat = date.toISOString().split("T")[0];
                          lastWeek.push(dataFormat);
                        }
                        lastWeek = [...lastWeek].reverse();
                        setFilter({
                          ...clearFilter,
                          dateFrom: lastWeek[0],
                          dateTo: lastWeek[lastWeek.length - 1],
                        });
                      }}
                    >
                      Last Week
                    </Button>}
                  </div>
                </div>
                <div
                  style={{
                    height: "100%",
                    width: "1px",
                    backgroundColor: "#000",
                    margin: "0 12px",
                  }}
                ></div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 5,
                  }}
                >
                  <div style={{ gap: 10, display: "flex" }}>
                    <Button
                      variant="contained"
                      height={4}
                      sx={{
                        fontWeight: 900,
                        backgroundColor: "#2d2d2d !important",
                        "&:hover": {
                          backgroundColor: "#eaeaea !important",
                          color: "#131C2D",
                        },
                      }}
                      style={{
                        fontSize: 10.5,
                        padding: 1,
                        paddingRight: 3,
                        paddingLeft: 3,
                      }}
                      onClick={() => {
                        setFilter({ ...clearFilter, smartFilter: true });
                      }}
                    >
                      Smart
                    </Button>
                    <Button
                      variant="contained"
                      height={4}
                      sx={{
                        fontWeight: 900,
                        backgroundColor: "#2d2d2d !important",
                        "&:hover": {
                          backgroundColor: "#eaeaea !important",
                          color: "#131C2D",
                        },
                      }}
                      style={{
                        fontSize: 10.5,
                        padding: 1,
                        paddingRight: 3,
                        paddingLeft: 3,
                      }}
                      onClick={() => {
                        setFilter({ ...clearFilter, tipo: [1] });
                      }}
                    >
                      Critical
                    </Button>
                    <Button
                      variant="contained"
                      height={4}
                      sx={{
                        fontWeight: 900,
                        backgroundColor: "#2d2d2d !important",
                        "&:hover": {
                          backgroundColor: "#eaeaea !important",
                          color: "#131C2D",
                        },
                      }}
                      style={{
                        fontSize: 10.5,
                        padding: 1,
                        paddingRight: 3,
                        paddingLeft: 3,
                      }}
                      onClick={() => {
                        setFilter({ ...clearFilter, tipo: [0] });
                      }}
                    >
                      High
                    </Button>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                <DraggableButton
                  className="typeFilter"
                  color={filter.tipo.length > 0 && "whitesmoke"}
                  textcolor={filter.tipo.length > 0 && "#131C2D"}
                  type="tipo"
                  onDrop={handleOpenDialog}
                  onClick={() => {
                    handleOpenDialog("tipo");
                  }}
                >
                  Filter by Type
                </DraggableButton>
                <DraggableButton
                  className="dateFilter"
                  color={filter.dateTo && "whitesmoke"}
                  textcolor={filter.dateTo && "#131C2D"}
                  type="data"
                  onClick={() => {
                    handleOpenDialog("data");
                  }}
                  onDrop={handleOpenDialog}
                >
                  Filter by Date
                </DraggableButton>
                <DraggableButton
                  className="detailFilter"
                  color={filter.dettaglio.length > 0 && "whitesmoke"}
                  textcolor={filter.dettaglio.length > 0 && "#131C2D"}
                  type="dettaglio"
                  onClick={() => {
                    handleOpenDialog("dettaglio");
                  }}
                  onDrop={handleOpenDialog}
                >
                  Filter by Detail
                </DraggableButton>
                <DraggableButton
                  className="ipFilter"
                  color={(filter.ip1 || filter.ip2 || filter.nip1 || filter.nip2) && "whitesmoke"}
                  textcolor={(filter.ip1 || filter.ip2 || filter.nip1 || filter.nip2) && "#131C2D"}
                  type="ip"
                  onClick={() => {
                    handleOpenDialog("ip");
                  }}
                  onDrop={handleOpenDialog}
                >
                  Filter by IP
                </DraggableButton>
                <DraggableButton
                  className="subnetFilter"
                  color={filter.subnet && "whitesmoke"}
                  textcolor={filter.subnet && "#131C2D"}
                  type="dettaglio"
                  onClick={() => {
                    handleOpenDialog("subnet");
                  }}
                  onDrop={handleOpenDialog}
                >
                  Filter by Subnet
                </DraggableButton>
              </div>
              <div
                style={{
                  marginRight: 5,
                  gap: 15,
                  marginBottom: -50,
                  display: "flex",
                  alignSelf: "flex-end",
                }}
              >
                <Button
                  variant="contained"
                  disabled={
                    filter.tipo.length === 0 &&
                    !filter.dateFrom &&
                    !filter.dateTo &&
                    filter.dettaglio.length === 0 &&
                    !filter.ip1 &&
                    !filter.ip2 &&
                    !filter.subnet
                  }
                  height={4}
                  sx={{
                    fontWeight: 900,
                    backgroundColor: "#2d2d2d !important",
                    mb: 1,
                    "&:hover": {
                      backgroundColor: "#eaeaea !important",
                      color: "#131C2D",
                    },
                  }}
                  style={{
                    fontSize: 10.5,
                    padding: 1,
                    paddingRight: 3,
                    paddingLeft: 3,
                  }}
                  onClick={handleOpenRemoveDialog}
                >
                  Remove Filter
                </Button>
              </div>
            </Box>
            <Box
              gridColumn="span 7"
              gridRow="span 3"
              backgroundColor={"#1E1E1E"}
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderRadius="25px"
              className="logsTable"
            >
              {" "}
              {charged ? (
                <TableADV
                  refDetail={detailGraphSelected}
                  setDetailSelected={setDetailSelected}
                  responseApi={apiResponse}
                  selectedTipo={selectedTipo}
                  filter={filter}
                />
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <CircularIndeterminate charged={charged} title="No Data" />
                </Box>
              )}
            </Box>
            <Box
              sx={[boxStyle, {p: 2, gridColumn: { xs: "span 12", md: "span 5" } }]}
              gridRow="span 2"
              display="flex"
              alignItems="center"
              justifyContent="center"
              className="typesGraph"
            >
              {charged ? (
                <LinearGraph filter={filter} responseApi={apiResponse} />
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <CircularIndeterminate charged={charged} title="No Data" />
                </Box>
              )}
            </Box>
            <Box
              sx={boxStyle}
              gridColumn="span 12"
              gridRow="span 5"
              display="flex"
              alignItems="center"
              justifyContent="center"
              className="ThreeDaysGraph"
            >
              {charged ? (
                <DropBox
                  filter={filter}
                  apiResponse={apiResponse}
                  onDrop={(filterType) =>
                    handleOpenDialog({ [filterType]: [] })
                  }
                />
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <CircularIndeterminate charged={charged} title="No Data" />
                </Box>
              )}
            </Box>
          </DndProvider>

          {sessionStorage.getItem("tipoLecs") !== "LECS-CORE-SFP" &&
            sessionStorage.getItem("tipoLecs") !== "LECS-CORE-4-PRO" ? (
            <Box
              sx={boxStyle}
              gridColumn="span 12"
              gridRow="span 4"
              display="flex"
              alignItems="center"
              justifyContent="center"
              className="ThreeDaysGraph"
              pt={3}
              pb={10}
              pl={3}
              pr={3}
            >
              <AdvancedHeatMap />
            </Box>
          ) : null}
        </Box>
      </Box>
    </>
  );
};

export default AdvancedVisual;
